import {
  Step,
  StepConnector,
  stepConnectorClasses,
  stepIconClasses,
  StepLabel,
  stepLabelClasses,
  Stepper,
} from '@mui/material'
import { StepIconProps } from '@mui/material/StepIcon'
import { styled } from '@mui/material/styles'

import { useStepper } from './stepper.hook'

const themePrimaryColor = '#f5bb78'

const CustomConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 19,
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 2,
    border: 0,
    borderRadius: 1,
    backgroundColor: '#E2E2E2',
  },
  [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}`]: {
    backgroundColor: themePrimaryColor,
  },
  [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: {
    backgroundColor: themePrimaryColor,
  },
}))

const StepIconRoot = styled('div')(({ theme }) => ({
  [`&.${stepIconClasses.root}`]: {
    backgroundColor: '#C2C2C2',
    color: 'white',
    borderRadius: '50%',
    width: 34,
    height: 34,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0px',
  },
  [`&.${stepIconClasses.active}`]: {
    border: `3px solid ${themePrimaryColor}`,
    backgroundColor: 'white',
    color: themePrimaryColor,
    width: 42,
    height: 42,
  },
  [`&.${stepIconClasses.completed}`]: {
    backgroundColor: themePrimaryColor,
    color: 'white',
  },
}))

const CustomStepIcon = (props: StepIconProps) => {
  const { active, completed, className } = props

  return (
    <StepIconRoot
      className={[
        stepIconClasses.root,
        active ? stepIconClasses.active : '',
        completed ? stepIconClasses.completed : '',
        className,
      ].join(' ')}
    >
      {completed ? '✓' : ''}
    </StepIconRoot>
  )
}

const StyledStepLabel = styled(StepLabel)(({ theme }) => ({
  [`& .${stepLabelClasses.label}`]: {
    fontWeight: 300, // normale
    // fontFamily: "SofiaPro-Light",
    fontFamily: 'sofia-pro',
  },
  [`& .${stepLabelClasses.label}.${stepLabelClasses.active}`]: {
    fontWeight: 500, // bold se attivo
    fontSize: 16,
  },
}))

export const DataEntryStepper = ({ currentStep }: { currentStep: number }) => {
  const { visibleSteps, visualActiveStep } = useStepper(currentStep)

  return (
    <Stepper activeStep={visualActiveStep} alternativeLabel connector={<CustomConnector />}>
      {visibleSteps.map((step, index) => {
        return (
          <Step key={step} completed={index < visualActiveStep}>
            <StyledStepLabel slots={{ stepIcon: CustomStepIcon }}>{step}</StyledStepLabel>
          </Step>
        )
      })}
    </Stepper>
  )
}
